module.exports = __webpack_public_path__ + "static/images/success-2-blue.26d0090.png";